import { render, staticRenderFns } from "./SkinRegimenRecord.vue?vue&type=template&id=20b0c653&scoped=true&"
import script from "./SkinRegimenRecord.vue?vue&type=script&lang=js&"
export * from "./SkinRegimenRecord.vue?vue&type=script&lang=js&"
import style0 from "../../assets/print.css?vue&type=style&index=0&id=20b0c653&scoped=true&lang=css&"
import style1 from "./SkinRegimenRecord.vue?vue&type=style&index=1&id=20b0c653&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b0c653",
  null
  
)

export default component.exports